import { Box, Theme } from "@mui/material";
import dayjs from "dayjs";
import { TFunction } from "i18next";
import ReactDOMServer from "react-dom/server";
import { dashboardChartTooltipDateFormatter } from "src/components/Dashboard/helpers/dashboardChart.helper";
import { ChartTooltipFormatterParams } from "src/components/Dashboard/interfaces/DashboardComponentParams";
import IntervalType from "src/constants/intervalType.enum";
import { formatNum } from "src/lib/number.helpers";

import { getStyles } from "../utils/styles";

export function dashboardChartTooltipFormatter(
  params: ChartTooltipFormatterParams,
  intervalType: IntervalType,
  t: TFunction,
  theme: Theme
): string {
  const styles = getStyles(theme);

  const list = Array.isArray(params) ? params : [params];
  const tooltipDate = dayjs(list[0].name as string);
  const header = dashboardChartTooltipDateFormatter(intervalType, tooltipDate, t);

  const rows = list.map((param, index) => {
    const paramData = param.data as unknown[];
    const value = paramData[1] as number | undefined;

    return (
      <Box style={styles.popupRow2Cols} key={index}>
        <Box style={styles.popupCol}>
          <Box style={styles.row}>
            <Box style={getStyles(theme, param.color).box} />
            <Box style={styles.textPrimary}>{param.seriesName}</Box>
          </Box>
        </Box>

        <Box style={styles.popupCol}>
          <Box style={styles.textPrimaryBold}>{formatNum(value ?? 0)}</Box>
        </Box>
      </Box>
    );
  });

  return ReactDOMServer.renderToString(
    <Box>
      <Box style={styles.textSecondary}>{header}</Box>
      {rows}
    </Box>
  );
}
